import { render, staticRenderFns } from "./FormResetPassword.vue?vue&type=template&id=86ae0d34"
import script from "./FormResetPassword.vue?vue&type=script&lang=js"
export * from "./FormResetPassword.vue?vue&type=script&lang=js"
import style0 from "./FormResetPassword.vue?vue&type=style&index=0&id=86ae0d34&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports